import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, title: String, text: String, source: String }

  copy() {
    const text = this.textValue
    if (!text) return
    this._writeAndFeedback(text)
  }

  copyFromSource() {
    const id = this.sourceValue
    if (!id) return
    const el = document.getElementById(id)
    const text = el?.value ?? el?.textContent ?? ""
    if (!text) return
    this._writeAndFeedback(text)
  }

  _writeAndFeedback(text) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => {
        const btn = this.element.querySelector("button") ?? this.element
        const originalHtml = btn.innerHTML
        btn.innerHTML = '<span class="material-symbols-outlined text-lg">check</span> Copied!'
        btn.disabled = true
        setTimeout(() => {
          btn.innerHTML = originalHtml
          btn.disabled = false
        }, 2000)
      })
    } else {
      window.prompt("Copy to clipboard:", text)
    }
  }

  share() {
    const url = this.urlValue
    if (navigator.share) {
      navigator.share({ title: this.titleValue, url })
    } else if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(() => {
        const lbl = this.element.querySelector(".share-lbl")
        if (lbl) {
          lbl.textContent = "Copied!"
          setTimeout(() => { lbl.textContent = "Share" }, 2000)
        }
      })
    } else {
      window.prompt("Copy invoice link:", url)
    }
  }
}
